<script setup lang="ts">
import dayjs from 'dayjs';
import { computed } from 'vue';

// Props
// ===============================
const props = defineProps<{
  id: number;
  name: string;
  messagePreview: string;
  timestamp: string;
}>();

// Emits
// ===============================
const emit = defineEmits<{
  (e: 'clicked', id: number): void;
}>();

// Computed Properties
// ===============================
const initials = computed(() => {
  if (!props.name?.length) {
    return 'UK'; // unknown initials
  }

  return props.name
    .split(' ')
    .slice(0, 2)
    .map((name) => name[0])
    .join('');
});

const displayTimestamp = computed(() => {
  return dayjs(props.timestamp).format('MMM DD hh:mm A');
});

// Methods
// ===============================
const handleClick = () => {
  emit('clicked', props.id);
};
</script>

<template>
  <div class="flex w-full cursor-pointer p-3 hover:bg-highlight-0" @click="handleClick">
    <div class="mr-2 block h-full w-8 rounded-full bg-tint-40">
      <div
        class="flex h-8 w-8 items-center justify-center text-xs font-bold leading-[18px] text-shade-800"
      >
        {{ initials }}
      </div>
    </div>
    <!-- Content-->
    <div class="block w-[308px] flex-grow">
      <!-- Details -->
      <div class="mb-2 h-[24px]">
        <!-- Name/Date -->
        <div class="flex items-center justify-between">
          <div class="w-[calc(100%-120px)] truncate text-shade-880">
            <span class="sensitive text-sm font-bold leading-[21px]">
              {{ name }}
            </span>
            <span class="truncate text-sm font-normal leading-[21px]"> messaged you</span>
          </div>
          <div class="min-w-[100px] text-xs font-normal leading-[18px] text-shade-820">
            {{ displayTimestamp }}
          </div>
        </div>
      </div>
      <!-- Message Preview -->
      <div class="line-clamp-3 text-sm font-normal text-shade-900">
        {{ messagePreview }}
      </div>
    </div>
  </div>
</template>
